<template>
  <div class="brand-logo">
    <h4>品牌LOGO</h4>
    <ul>
      <li class="upload-li" v-if="loginInfo.current_team_role !== 4">
        <el-upload
          class="logo-uploader"
          :http-request="uploadImage"
          :show-file-list="false"
          multiple
          limit="10"
          accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG,"
          :data="uploadType"
          :on-exceed="handleExceed"
        >
          <i class="avatar-uploader-icon icon-Addto iconfont"></i>
          <p>上传LOGO</p>
        </el-upload>
      </li>
      <li class="logo-li" v-for="(item, index) in logoList" :key="item.id">
        <div class="img-box">
          <img :src="item.url" @error="logoLoadError(item, index)" />
          <span
            class="iconfont icon-More font-icon-more more-act"
            @click.stop="checked(index)"
            v-if="loginInfo.current_team_role !== 4"
          ></span>
          <div class="action" v-show="checkedIndex === index">
            <p @click="renameOpen(item)">重命名</p>
            <p @click="downImg(item)">下载</p>
            <p @click="removeOpen(item)">删除</p>
          </div>
        </div>
        <p class="text-hidden">{{ item.name }}</p>
      </li>
    </ul>
    <rename-dialog ref="renameDialog" @submit="submitRename" />
    <remove-dialog :title="'是否确认删除该LOGO'" @remove="removeFolder" />
    <!--过期弹出框-->
    <expireTeamDialog />
  </div>
</template>

<script>
import { Brand } from "@/config/axios/new_api";
import renameDialog from "@/components/dialog/renameDialog.vue";
import RemoveDialog from "@/components/dialog/removeDialog.vue";
export default {
  components: { renameDialog, RemoveDialog },
  props: ["BrandInfo"],
  data() {
    return {
      checkedIndex: null,
      selectedObj: {},
      renameInput: "",
      renameStatus: false,
      removeDialogStatus: false,
      fontremoveenable: false,
    };
  },
  computed: {
    logoList() {
      return this.BrandInfo.logos;
    },
    uploadType() {
      return {
        type: "logo",
        team_id: this.BrandInfo.id,
      };
    },
    headers() {
      return {
        user_uuid: this.staticFunc.getCookie("user_uuid"),
      };
    },
    loginInfo() {
      return this.$store.getters.loginInfo;
    },
  },
  mounted() {
    document.addEventListener("click", this.resetChecked, false);
  },
  methods: {
    imgError(item) {
      item.url = item.url.split("?")[0];
    },
    resetChecked() {
      this.checkedIndex = null;
    },
    checked(index) {
      if (this.checkedIndex === index) {
        this.checkedIndex = 0;
        this.selectedObj = {};
      } else {
        this.checkedIndex = index;
      }
    },
    renameOpen(item) {
      this.renameStatus = true;
      this.selectedObj = item;
      this.renameInput = item.name;
      // this.$refs.renameDialog.renameObj.renameInput = item.name;
    },
    submitRename() {
      let submitData = {
        re_name: this.$refs.renameDialog.renameObj.renameInput,
        resource_id: this.selectedObj.id,
      };
      Brand.renameLogo(submitData).then((res) => {
        if (res.status === 1) {
          this.renameStatus = false;
          this.renameInput = "";
          this.$emit("getData");
        }
      });
    },
    downImg(item) {
      let res = this.expireHandle();
      if (res) {
        Brand.downloadLogo({team_id: this.loginInfo.current_team_id, resource_id: item.id}).then(res =>{
          if (res.status == 1) {
            if(res.data == 1) {
              var url = item.url;

              if (url.indexOf("?x-oss-process") > -1) {
                url = url.split("?x-oss-process")[0];
              }

              var dotIndex = url.lastIndexOf(".") + 1;
              var fileTypeStr = url.slice(dotIndex);
              var filename = item.name;
              if (filename.indexOf(fileTypeStr) > -1) {
                var namedotIndex = item.name.lastIndexOf(".");
                filename = item.name.slice(0, namedotIndex);
              }

              this.staticFunc.downloadImg(url, filename.replace(/\./, ""));
            }else {
              this.$message.error(res.message);
            }
            
          }
        });
      }
    },
    removeOpen(item) {
      this.removeDialogStatus = true;
      this.selectedObj = item;
    },
    removeFolder() {
      Brand.deleteLogo({
        resource_id: this.selectedObj.id,
      }).then((res) => {
        if (res.status === 1) {
          this.selectedObj = null;
          this.removeDialogStatus = false;
          this.$emit("getData");
        }
      });
    },
    uploadImage(params) {
      let res = this.expireHandle();
      if (res) {
        let file = params.file;
        var dotIndex = file.name.lastIndexOf(".") + 1;
        var fileTypeStr = file.name.slice(dotIndex);
        let img = ["png", "jpeg", "jpg"];
        if (!img.includes(fileTypeStr)) {
          this.$message({
            message: "请上传png、jpeg、jpg图片",
            center: true,
            customClass: "handle-success",
          });
          return;
        }
        let data = {
          file: file,
          format: fileTypeStr,
          upload_type: 'logo'
        };
        this.staticFunc.qyUploadImg(data, (res) => {
          if (res.status === 1) {
            Brand.uploadLogo({
              team_id: this.loginInfo.current_team_id,
              file_name: res.data.filename,
              height: res.data.height,
              width: res.data.width,
              size: res.data.size
            }).then(res => {
              if(res.status == 1) {
                this.$message.success("上传成功");
                this.$emit("getData");
              }
            })
          } else {
            this.$message.error(res.message);
          }
        })
      }
    },
    logoLoadError(item, index) {
      let url = item.url;
      if (url.indexOf("?x-oss-process") > -1) {
        url = url.split("?x-oss-process")[0];
        item.url = url;

        this.$set(this.logoList, `${index}`, item);
      }
    },
    handleExceed(files) {
      this.$message({
        message: "单次上传文件不能超过10个",
        center: true,
        customClass: "handle-success",
      });
      var ary = [];
      var obj = {};
      for (var key in files) {
        if (key < 10) {
          ary.push(files[key]);
        }
      }
      ary.map((item) => {
        obj = {
          file: item,
        };
        this.uploadImage(obj);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.brand-logo {
  li {
    height: 178px;
    margin-bottom: 20px;
    text-align: center;

    &.upload-li {
      padding-top: 30px;
    }
    &.logo-li {
      width: 150px;
      .img-box {
        @include wh(150px, 150px);
        border-radius: 8px;
        margin-bottom: 8px;
        position: relative;
        cursor: pointer;
        transition: all 0.3s;
        background-image: linear-gradient(to top right, #f4f4f4 25%, transparent 0, transparent 75%, #f4f4f4 0, #f4f4f4),linear-gradient(to top right, #f4f4f4 25%, transparent 0, transparent 75%, #f4f4f4 0, #f4f4f4);
        background-position: 0 0,6px 6px;
        background-size: 12px 12px;

        &:hover {
          background: $hoverColor;
          .more-act {
            display: block;
          }
        }
        img {
          @include wh(100%, 100%);
          object-fit: scale-down;
        }
        // .el-icon-more {
        //   @include wh(16px, 16px);
        //   background: rgba(0, 0, 0, 0.6);
        //   border-radius: 2px;
        //   font-size: 10px;
        //   color: #fff;
        //   position: absolute;
        //   bottom: 8px;
        //   right: 8px;
        //   z-index: 99;
        //   text-align: center;
        //   line-height: 16px;
        //   cursor: pointer;
        //   display: none;
        // }
        .action {
          width: 160px;
          background: #fff;
          box-shadow: 0px 0px 20px 0px rgba(175, 175, 175, 0.44);
          border-radius: 8px;
          text-align: center;
          padding: 0 5px;
          border: none;
          box-sizing: border-box;
          position: absolute;
          top: 150px;
          left: 120px;
          z-index: 99;
          margin-bottom: 10px;
          p {
            line-height: 44px;
            height: 45px;
            font-size: 14px;
            font-weight: 400;
            color: #424244;
            &:hover {
              color: $activeColor;
            }
          }
        }
      }
      > p {
        @include wh(150px, 20px);
        font-size: 14px;
        font-weight: 400;
        color: #3c3c43;
        line-height: 20px;
      }
    }
  }
}
</style>
